import { Trans, useLingui } from '@lingui/react/macro';

import { InputSelect } from '@/design_system/InputSelect/InputSelect';
import { OptionalLabel } from '@/design_system/Label/OptionalLabel';
import { useUpdateArticle } from '@/models/article';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';
import { useDatabaseTranslation } from '@/services/i18n';

export const PurchaseChannel = () => {
  const { t } = useLingui();
  const { _db } = useDatabaseTranslation();
  const { request, article, view, errors } = useArticleContext();

  const { mutate: updateArticle } = useUpdateArticle({
    articleId: article.id,
    requestId: request.id,
  });

  return (
    <InputSelect
      variant="select"
      label={
        <>
          <Trans id="article.form.purchase-channel.label">Purchase channel</Trans>
          {!view.warranty.fields.purchaseChannel.required && <OptionalLabel />}
        </>
      }
      placeholder={t({
        id: 'article.form.purchase-channel.placeholder',
        message: 'Select a purchase channel',
      })}
      value={article.purchaseChannel}
      options={view.warranty.fields.purchaseChannel.options}
      getOptionValue={(option) => option.en}
      getOptionLabel={(option) => _db(option)}
      onChange={(option) => {
        updateArticle({ data: { purchaseChannel: option ?? null } });
      }}
      isClearable
      style={{ flex: 1 }}
      error={
        errors?.warranty?.missingPurchaseChannel
          ? t({
              id: 'article.form.purchase-channel.error',
              message: 'Please select a purchase channel',
            })
          : undefined
      }
    />
  );
};
